export const DEFAULT_ERR_MSG = 'We are unable to process the request at this time. Please try after sometime';
export const ERROR_MSG = 'Looks like something went wrong. Please try again!';

export const CPC_AVAILABLE_PLANS = 'CPC_AVAILABLE_PLANS';
export const CPC_WHW_ELIGIBLE_RESPONSE = 'CPC_WHW_ELIGIBLE_RESPONSE';
export const SELECTED_PLANS_FEATURES = 'SELECTED_PLANS_FEATURES';
export const RETRIEVE_CART_VPM_RESPONSE = 'RETRIEVE_CART_VPM_RESPONSE';
export const AGREEMENT_DETAILS_DATA = 'AGREEMENT_DETAILS_DATA';
export const AGREEMENTS_API_SUCCESS = 'AGREEMENTS_API_SUCCESS';
export const VPM_ORDER_NUMBER = 'VPM_ORDER_NUMBER';
export const CPC_ORDER_WRITE_RESPONSE = 'CPC_ORDER_WRITE_RESPONSE';
export const CPC_ORDER_WRITE_ERROR = 'CPC_ORDER_WRITE_ERROR';
export const RETRIEVE_CART_VPM_RESPONSE_STATUS = 'RETRIEVE_CART_VPM_RESPONSE_STATUS';
export const SET_WHW_DOWNGRADE_FLOW = 'SET_WHW_DOWNGRADE_FLOW';
export const INIT_JWT_CPC_API = 'INIT_JWT_CPC_API';
export const INIT_JWT_CPC_API_ERROR = 'INIT_JWT_CPC_API_ERROR';
export const VPM_CONFIRMATION_API = 'VPM_CONFIRMATION_API';
export const VPM_MDN = 'VPM_MDN';
export const VPM_ACCOUNT_NUMBER = 'VPM_ACCOUNT_NUMBER';
export const IS_PLAN_DOWNGRADE = 'IS_PLAN_DOWNGRADE';

// Flow Types
export const FLOW_TYPES = {
  FEATURE_CHANGE: 'FC',
  PLAN_CHANGE: 'PC',
};

// Feature Categories
export const FEATURE_CATEGORIES = {
  WHW_PLUS: 'WHWPLUS',
  WHW_BASIC: 'WHWBASIC',
};

// Transaction Types
export const TRANSACTION_TYPES = {
  FEATURE_ACCESSORY: 'FEA_ACC',
  FEATURE: 'FEA',
  CPC_FEATURE_ACCESSORY: 'CPC_FEA_ACC',
  CPC_FEATURE: 'CPC_FEA',
  CPC: 'CPC',
};

// Feature Flags
export const FEATURE_FLAGS = {
  VPM_AVAILABLE_PLAN: 'vpmAvailablePlanFFlag',
  VPM_FEATURE_AND_PLAN: 'vpmFeatureAndPlanFFlag',
};